<template>
    <div class="container">

        <div v-if="isBeforeLaunchDate && (user.is_student_resident_or_employee ==='S')"> 
            <v-alert type="info" outlined dense>Please log in after {{ launchdate }} to start buying new permits. Thank you!</v-alert>
        </div>
        <div v-if="user.receipts.length > 0 && user.vehicles.length ===0">
            <v-alert type="error" dense outlined >You have not registered a vehicle.  The parking hang tag is not valid and will not be distributed until a vehicle is registered.  Please do so now.</v-alert>
        </div>
<!--        Dialog for add/edit vehicle-->
        <v-dialog v-model="dialog" max-width="800px" >
            <v-card>
                <v-card-title>
                    <span class="mx-4 my-4 inline-block bg-green-200 rounded-full px-3 py-1 text-sm font-semibold text-green-700 mr-2">{{formTitle}}</span>
                </v-card-title>
                <v-card-text>
                    <div class="px-2">
                        <div class="flex flex-wrap justify-start items-center -mx-4">
                            <div class="px-2 w-full">
                                <v-text-field v-model="editedItem.plate_number"  prepend-icon="directions_car" :rules="[rules.required]" persistent-hint hint="Please enter license plate without any spaces." label="Vehicle Plate Number"></v-text-field>
                            </div>
                            <div class="px-2 w-full">
                                <v-text-field v-model="editedItem.vehicle_year"  prepend-icon="calendar_today" :rules="[rules.required]" label="Year"></v-text-field>
                            </div>
                            <div class="px-2 w-full">
                                <v-select v-model="editedItem.vehicle_color"  :items="vehiclecolors" item-text="vc_color_desc" :rules="[rules.required]" item-value="vc_color_code" prepend-icon="directions_car" label="Vehicle Color"></v-select>
                            </div>
                            <div class="px-2 w-full">
                                <v-select v-model="editedItem.vehicle_make"  :items="vehiclemakes" item-text="vc_make_desc" :rules="[rules.required]" item-value="vc_make_cd" prepend-icon="directions_car" label="Vehicle Make"></v-select>
                            </div>
                            <div class="px-2 w-full">
                                <v-select v-model="editedItem.plate_state"  :items="vehiclestates" item-text="desc" :rules="[rules.required]" item-value="state" prepend-icon="directions_car" label="Vehicle State"></v-select>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn :loading="isUpdatingVehicle" color="blue darken-1" text @click="save(editedItem)">{{buttonName}}</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
<!--        End of dialog-->
        <!--        Check for permits-->
        <div class="flex flex-wrap justify-between items-center">
            <div>
                <span class="text-xl inline-block bg-green-200 rounded-full px-3 py-1 font-semibold mr-2">Your Receipts</span>
            </div>
        </div>
        <div class="mt-10" v-if="user.receipts.length > 0 && user.receipts.length <= 3">
            <div v-if="user.receipts.length < 3" class="flex flex-wrap justify-end items-center">
                <div>
                    <v-btn :href="appURL + '/permit/create'" color="primary"><v-icon>add</v-icon>Get New Permit</v-btn>
                </div>
            </div>
            <div class="px-2 mt-5">
                <div class="flex flex-wrap justify-start items-center -mx-4">
                    <div v-for="(receipt, i) in user.receipts" :key="i" class="px-2 w-full md:w-1/3 my-3">
                        <v-card raised>
                            <v-card-title>Receipt for permit number {{ receipt.permit_number.substr(1,10)}}</v-card-title>
                            <v-card-subtitle>{{ receipt.description }}</v-card-subtitle>
                            <v-card-text>
                                <div class="px-2">
                                    <div class="flex flex-wrap justify-start items-center -mx-4">
                                        <span class="text-md font-semibold font-sans">Permit Information</span>
                                        <div class="px-2 w-full">
                                            <v-text-field v-model="receipt.customer_name" prepend-icon="person" label="Name" disabled></v-text-field>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-text-field v-model="receipt.permit_number_series_code" prepend-icon="directions_car" label="Permit Series" disabled></v-text-field>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-text-field v-model="receipt.issued_date" prepend-icon="directions_car" label="Permit Issue Date" disabled></v-text-field>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-text-field v-model="receipt.permit_year" prepend-icon="directions_car" label="Permit Year" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn :href="appURL + '/receipt/' + receipt.permit_number" color="success"><v-icon>mdi-eye</v-icon>View Receipt</v-btn>
                            </v-card-actions>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-10" v-else-if="user.receipts.length === 0">
            <v-alert border="left" color="error" outlined icon="error" prominent>
                <v-row align="center">
                    <v-col class="grow">Looks like you do not have any Permits assigned! Please get one by following the "Buy Permit" button!</v-col>
                    <v-col class="shrink"><v-btn :href="appURL + '/permit/create'" color="primary"><v-icon>add</v-icon>Buy Permit</v-btn></v-col>
                </v-row>
            </v-alert>
        </div>
<!--        End for permit logic-->
<!--        Check for vehicles-->
        <div v-if="user.vehicles.length > 0 && user.vehicles.length <= 3" class="mt-5">
            <div class="flex flex-wrap justify-between items-center mt-5">
                <div>
                    <span class="text-xl inline-block bg-green-200 rounded-full px-3 py-1 font-semibold mr-2">Your Vehicles</span>
                </div>
            </div>
            <div class="flex flex-wrap justify-between items-center mt-5">
                <div>
                    <v-alert dense outlined type="info">Please review your vehicles below and make sure to include the updated information.You can add upto 3 vehicles and edit/delete the vehicle information as per your requirements.</v-alert>
                </div>
            </div>
            <div v-if="user.vehicles.length < 3" class="flex flex-wrap justify-end items-center my-4">
                <div>
                    <v-btn @click="addnewVehicle" color="primary"><v-icon>add</v-icon>Add Vehicle</v-btn>
                </div>
            </div>
            <div class="px-2">
                <div class="flex flex-wrap justify-start items-center -mx-4">
                    <div v-for="(vehicle, index) in user.vehicles" :key="index" class="px-2 w-full md:w-1/3 my-3">
                        <v-card raised>
                            <v-card-title>
                                <span>Vehicles Registered</span>
                                <v-spacer></v-spacer>
                                <v-icon color="red" small class="mr-2" @click="editItem(vehicle)">mdi-pencil</v-icon>
                                <v-icon @click="deleteItem(vehicle)" small class="mr-2" color="red darken-2">mdi-delete</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <div class="px-2">
                                    <div class="flex flex-wrap justify-start items-center -mx-4">
                                        <span class="text-md font-semibold font-sans">Vehicles</span>
                                        <div class="px-2 w-full">
                                            <v-text-field v-model="vehicle.plate_number" prepend-icon="directions_car" label="Vehicle Plate Number" :disabled="vehicle1Disabled"></v-text-field>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-text-field v-model="vehicle.vehicle_year" prepend-icon="calendar_today" label="Year" :disabled="vehicle1Disabled"></v-text-field>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-select v-model="vehicle.vehicle_color" :items="vehiclecolors" item-text="vc_color_desc" item-value="vc_color_code" prepend-icon="directions_car" label="Vehicle Color" :disabled="vehicle1Disabled"></v-select>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-select v-model="vehicle.vehicle_make" :items="vehiclemakes" item-text="vc_make_desc" item-value="vc_make_cd" prepend-icon="directions_car" label="Vehicle Make" :disabled="vehicle1Disabled"></v-select>
                                        </div>
                                        <div class="px-2 w-full">
                                            <v-select v-model="vehicle.plate_state" :items="vehiclestates" item-text="desc" item-value="state" prepend-icon="directions_car" label="Vehicle State" :disabled="vehicle1Disabled"></v-select>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-10" v-else>
            <v-alert border="left" color="error" outlined icon="error" prominent>
                <v-row align="center">
                    <v-col class="grow">Looks like you do not have any vehicles registered! Please follow the "Add Vehicles" button to add one!</v-col>
                    <v-btn class="shrink" color="primary" @click="addnewVehicle"><v-icon>add</v-icon>Add Vehicle</v-btn>
                </v-row>
            </v-alert>
        </div>
<!--        End for vehicle logic-->
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: "IndexComponent.vue",
        data() {
            return {
                appURL: process.env.MIX_APP_URL,
                snack: false,
                snackColor: '',
                snackText: '',
                vehicle1Disabled: true,
                vehicle2Disabled: true,
                vehicle3Disabled: true,
                dialog: false,
                isUpdatingVehicle: false,
                rules: {
                    required: value => !!value || 'This field is required',
                    // vehiclePlateLength: v => (v || "").length < 8 || 'Length should be less than 8'
                },
                editedIndex: -1,
                editedItem:{
                    uin: null,
                    previous_plate_number: null,
                    previous_vehicle_state: null,
                    vehicle_plate_number: null,
                    vehicle_year: null,
                    vehicle_make: null,
                    vehicle_state: null,
                    vehicle_color: null,
                },
                defaultItem:{
                    uin: null,
                    previous_plate_number: null,
                    previous_vehicle_state: null,
                    vehicle_plate_number: null,
                    vehicle_year: null,
                    vehicle_make: null,
                    vehicle_state: null,
                    vehicle_color: null,
                }
            }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        created() {
            
        },
        props: {
            user: {
                required: true,
                type: Object
            },
            vehiclecolors: {
                required: true,
                type: Array
            },
            vehiclemakes: {
                required: true,
                type: Array
            },
            vehiclestates: {
                required: true,
                type: Array
            },
            launchdate: {
                required: false,
                type: String
            }
        },
        computed: {
            isBeforeLaunchDate : function () {
                const today = moment().format('yy-MM-DD');
                return moment(today).isBefore(this.launchdate);
            },
            formTitle() {
                return this.editedIndex === -1 ? 'New Vehicle' : 'Edit Vehicle'
            },
            buttonName() {
                return this.editedIndex === -1 ? 'Save' : 'Update'
            }
        },
        methods: {
            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
            },
            addnewVehicle: function () {
                this.editedIndex = -1;
                this.dialog = true;
            },
            editItem (item) {
                item.previous_plate_number = item.plate_number;
                item.previous_vehicle_state = item.plate_state;
                this.editedIndex = this.user.vehicles.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            save(item) {
                if (this.editedIndex > -1) {
                    this.isUpdatingVehicle = true;
                    axios.post(this.appURL + '/api/uservehicle/' + item.uin, {
                        _method: 'patch',
                        previous_plate_number: this.editedItem.previous_plate_number,
                        previous_vehicle_state: this.editedItem.previous_vehicle_state,
                        vehicle_plate_number: item.plate_number,
                        vehicle_state: item.plate_state,
                        vehicle_color: item.vehicle_color,
                        vehicle_make: item.vehicle_make,
                        vehicle_year: item.vehicle_year,
                    }).then((response) => {
                        if(response.status === 200) {
                            Object.assign(this.user.vehicles[this.editedIndex], item);
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Updated';
                        } else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.isUpdatingVehicle = false;
                        this.close();
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!';
                        this.isUpdatingVehicle = false;
                    });
                }
                else {
                    //Add vehicle
                    this.isUpdatingVehicle = true;
                    axios.post(this.appURL + '/api/uservehicle/', {
                        previous_plate_number: this.editedItem.previous_plate_number,
                        previous_vehicle_state: this.editedItem.previous_vehicle_state,
                        vehicle_plate_number: item.plate_number,
                        vehicle_state: item.plate_state,
                        vehicle_color: item.vehicle_color,
                        vehicle_make: item.vehicle_make,
                        vehicle_year: item.vehicle_year,
                    }).then((response) => {
                        if(response.status === 200) {
                            this.user.vehicles.push(response.data.vehicle)
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Added';
                        } else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.isUpdatingVehicle = false;
                        this.close();
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!';
                        this.isUpdatingVehicle = false;
                    });
                }
            },
            deleteItem: function (item) {
                const index = this.user.vehicles.indexOf(item);
                var answer = confirm('Are you sure you want to delete this vehicle?');
                if (answer) {
                    this.loadingUpdate = true;
                    axios.post(this.appURL + '/api/uservehicle/delete', {
                        plate_number: item.plate_number,
                        uin: item.uin,
                        state: item.plate_state,
                    }).then((response) => {
                        if (response.status === 200) {
                            this.user.vehicles.splice(index, 1);
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Deleted';
                        } else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.loadingUpdate = false;
                        this.close();
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!'
                        this.loadingUpdate = false;
                    });
                }
            },
        },
    }

</script>

<style scoped>

</style>
